import * as moment from 'moment';
import {isNullOrUndefined} from 'util';
import {FormControl, FormGroup, Validators} from '@angular/forms';

export class CalefaccionClass {
    form: FormGroup;
    public id: number = null;
    public mandosCal:boolean = null;
    public motorCal:boolean = null;

    constructor(data: any = null) {
        if (!isNullOrUndefined(data))
            Object.keys(data).map(i => this[i] = data[i]);

        this.form = new FormGroup({
            id: new FormControl(this.id),
            mandosCal: new FormControl({value: this.mandosCal, disabled: false}),
            motorCal: new FormControl({value: this.motorCal, disabled: false})
        });
    }
}
